





































import Vue from 'vue'
import mixins from 'vue-typed-mixins'
import Pagination from '@morpheus/utils/admin-vue/mixins/pagination'
import CodesList from '../components/CodesList.vue'
import CodesFilter from '../components/CodesFilter.vue'
import { fetchCodesList } from '../services/procodes-client'
import { CodesListData, CodesListItemData } from '../types'

export default mixins(Pagination).extend({
  name: 'PoolsCodes',
  components: {
    CodesList,
    CodesFilter
  },
  mixins: [Pagination],
  props: {
    id: {
      required: true,
      type: String
    }
  },
  data () {
    return {
      isLoading: true,
      headers: [
        { text: 'Value', value: 'value', sortable: false },
        { text: 'Status', value: 'status', sortable: false },
        { text: 'Created At', value: 'created_at', sortable: false },
        { text: 'Created By', value: 'created_by', sortable: false },
        { text: 'Reserved At', value: 'reserved_at', sortable: false },
        { text: 'Reserved By', value: 'reserved_by', sortable: false }
      ],
      itemsList: [],
      filterParams: ''
    }
  },
  mounted () {
    this.$store.commit('global/setLoading', true)
    this.fetchItems()
  },
  methods: {
    fetchItems () {
      this.isLoading = true
      fetchCodesList(`?limit=${this.rowsPerPage}&offset=${this.paginationOffset}${this.filterParams}`, this.id)
        .then(({ items, total }: CodesListData) => {
          this.itemsList.splice(0, this.itemsTotal)
          items.forEach((item: CodesListItemData, index: number) => {
            Vue.set(this.itemsList, index, item)
          })
          this.itemsTotal = total
        })
        .catch(error => {
          this.$store.commit('global/addNotification', { text: error.error, type: 'error' })
        })
        .finally(() => {
          this.checkPagination()
          this.$store.commit('global/setLoading', false)
          this.isLoading = false
        })
    },
    onApplyFilter (filter: string) {
      this.filterParams = filter
      // pagination reset - set 'offset' parameter to 0
      this.currentPage = 1
      this.fetchItems()
    }
  }
})
